import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Modal, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { myContainerStyle } from '../../../configs/ui/constant';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import MaterialTable from 'material-table';
import dayjs from 'dayjs';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import { Controller, useForm } from 'react-hook-form';
import Axios from 'axios';
import ViewTable from '../../../components/Modal/Rule/ViewTable';
import Create from '../../../components/Modal/Rule/Create';
import Edit from '../../../components/Modal/Rule/Edit';
import Delete from '../../../components/Modal/Rule/Delete';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import { useHistory } from 'react-router-dom';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import Increase from '../../../components/Modal/Rule/Increase';
import Decrease from '../../../components/Modal/Rule/Decrease';
import { useSnackbar } from 'notistack';
import { MySelect } from './../../../components/Select/Select';
import _ from 'lodash';
import DownloadExcel from './DownloadExcel';

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
}));

export default function SystemAdmin() {
   const tableRef = useRef();
   const history = useHistory();
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [resp, setResp] = useState([]);
   const [years, setYears] = useState([]);
   const [data, setData] = useState([]); // data that filled in table
   const [formattedData, setformattedData] = useState([]); // data that transform to frontend structure
   const [downloadData, setDownloadData] = useState([]); // data for download
   const [myModal, setMyModal] = useState('');
   const [showModal, setShowModal] = useState(false);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const { control, setValue } = useForm({
      defaultValues: {
         year: null,
      },
   });
   useEffect(() => {
      getData();
   }, []);
   const getData = () => {
      setIsLoading(true);
      Axios.get('/GSB/dashboard/rule/GetRuleList')
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               if (statusCode === 401) {
                  sessionStorage.clear();
                  localStorage.clear();
                  history.push('/');
               }
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoading(false);
         });
   };

   useEffect(() => {
      setTableData();
   }, [resp]);

   const setTableData = () => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  ...value,
                  relatedPersons: dataForMap.relatedEmployees ?? [],
               },
            );
         });
         setformattedData(formatted);
      }
   };

   useEffect(() => {
      setData(formattedData);
      setDownloadData(formattedData);
      setYearsDropdown(formattedData);
   }, [formattedData]);

   const setYearsDropdown = (data) => {
      let uniqYear = _.uniqBy(data, 'year').map((el) => {
         return {
            value: el.year,
            label: el.year,
         };
      });
      uniqYear = uniqYear.filter((el) => el.value !== null);
      uniqYear = _.orderBy(uniqYear, ['value', 'label'], ['desc', 'desc']);
      let maxYear = Math.max.apply(
         Math,
         uniqYear.map(function (o) {
            return o.value;
         }),
      );
      let maxYearObj = uniqYear.find((el) => el.value === maxYear);
      let currentYearObj = uniqYear.find(
         (el) => el.value === new Date().getFullYear() + 543,
      );
      uniqYear.unshift({ value: 'all', label: 'ทั้งหมด' });
      setYears(uniqYear);
      setValue('year', currentYearObj || maxYearObj);
      onSelectedYear(currentYearObj || maxYearObj);
   };

   const onSearchChange = () => {
      setDownloadData(tableRef.current.dataManager.searchedData);
   };

   const onSelectedYear = (e) => {
      if (e && e.value === 'all') {
         setData(formattedData);
         setDownloadData(formattedData);
      } else if (e) {
         let filterByYear = formattedData.filter((el) => el.year == e.value);
         setData(filterByYear);
         setDownloadData(filterByYear);
      } else {
         // select clear
         setData(formattedData);
         setDownloadData(formattedData);
      }
   };

   const editDataTable = (data) => {
      setShowModal(false);
      setModalStyle('edit', data);
   };
   const deleteDataTable = (data) => {
      setShowModal(false);
      setModalStyle('delete', data);
   };
   const increaseDataTable = (data) => {
      setShowModal(false);
      setModalStyle('increase', data);
   };
   const decreaseDataTable = (data) => {
      setShowModal(false);
      setModalStyle('decrease', data);
   };
   const refreshData = () => {
      setShowModal(false);
      setData([]);
      getData();
   };
   const setModalStyle = (type, value) => {
      if (type === 'view') {
         setMyModal(
            <ViewTable
               refID={value}
               onClickClose={() => setShowModal(false)}
               onClickEdit={editDataTable}
               onClickDelete={deleteDataTable}
               onClickIncrease={increaseDataTable}
               onClickDecrease={decreaseDataTable}
            />,
         );
      }
      if (type === 'create') {
         setMyModal(
            <Create
               onClickClose={() => setShowModal(false)}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'edit') {
         setMyModal(
            <Edit
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'delete') {
         setMyModal(
            <Delete
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'decrease') {
         setMyModal(
            <Decrease
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'increase') {
         setMyModal(
            <Increase
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      setShowModal(!showModal);
   };
   return (
      <Paper style={myContainerStyle.root}>
         <Modal className={classes.modal} open={showModal}>
            <React.Fragment>{myModal}</React.Fragment>
         </Modal>
         <Box display='flex' my={1} alignItems='center'>
            <Box mx={1}>
               <Typography variant='h5'>จัดการหลักเกณฑ์</Typography>
            </Box>
            <Box mx={1}>
               <Button
                  variant='contained'
                  color='primary'
                  size='small'
                  startIcon={<FontAwesomeIcon icon={faPlus} />}
                  onClick={() => {
                     setModalStyle('create', '');
                  }}
               >
                  เพิ่มหลักเกณฑ์
               </Button>
            </Box>
            <Box mx={1}>
               <Typography>ปี:</Typography>
            </Box>
            <Box width={150}>
               <Controller
                  as={
                     <MySelect
                        options={years}
                        placeholder={'เลือกปี'}
                        closeMenuOnSelect
                        menuShowInbody
                     />
                  }
                  onChange={([selected]) => {
                     onSelectedYear(selected);
                     return selected;
                  }}
                  name='year'
                  control={control}
               />
            </Box>
            <Box mx={1}>
               <DownloadExcel downloadData={downloadData} />
            </Box>
         </Box>
         <MaterialTable
            onSearchChange={onSearchChange}
            tableRef={tableRef}
            isLoading={isLoading}
            columns={[
               {
                  field: 'year',
                  title: 'ปี',
                  width: 100,
               },
               {
                  field: 'ruleCode',
                  title: 'รหัสหลักเกณฑ์',
                  width: 150,
               },
               {
                  field: 'ruleName',
                  title: 'ชื่อหลักเกณฑ์',
                  width: 500,
                  render: (rowData) => rowData.ruleNameTh,
               },
               {
                  field: 'ruleCondition',
                  title: 'เงื่อนไขการได้รับคะแนน',
                  width: 400,
                  render: (rowData) => rowData.ruleConditionTh,
               },
               {
                  field: 'ruleReferenceDescription',
                  title: 'แหล่งที่มาข้อมูล',
                  width: 200,
               },
               {
                  field: 'createdBy',
                  title: 'สร้างโดย',
                  width: 200,
               },
               {
                  field: 'updatedBy',
                  title: 'แก้ไขโดย',
                  width: 200,
               },
               {
                  field: 'createdDateLabel',
                  title: 'วันที่สร้าง',
                  type: 'datetime',
                  // render: (rowData) =>
                  //   dayjs(new Date(rowData.createdDate)).format('DD/MM/BBBB HH:mm'),
               },
               {
                  field: 'updatedDateLabel',
                  title: 'วันที่แก้ไข',
                  width: 200,
               },
            ]}
            data={data}
            options={{
               showTitle: false,
               headerStyle: headerStyle,
               padding: 'dense',
               pageSize: 5,
               pageSizeOptions: [5, 10, 25, 50, 100],
            }}
            style={tableStyle}
            icons={tableIcons}
            parentChildData={(row, rows) =>
               rows.find((a) => a.ruleId === row.parentId)
            }
            actions={[
               {
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        icon={faRedoAlt}
                        size={'xs'}
                     />
                  )),
                  tooltip: 'Refresh Data',
                  isFreeAction: true,
                  onClick: () => refreshData(),
               },
            ]}
            onRowClick={(e, rowData) => setModalStyle('view', rowData.ruleId)}
         />
      </Paper>
   );
}
